import { CommonDataServiceSink } from 'app/model/pipeline/copysink/common-data-service.copysink';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Metamodel } from 'app/model/base/model';
import { DynamicsSinkAdapter, dynamicsSinkAdapts } from './dynamics.sink.adapter';
import { IModel } from 'shell-models-lib';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(CommonDataServiceSink),
    asynchronous: true,
    adapts: dynamicsSinkAdapts
})
export class CommonDataServiceSinkAdapter extends DynamicsSinkAdapter {
    protected override model(): IModel {
        return CommonDataServiceSink.MODEL;
    }
}
